module.exports = __webpack_public_path__ + "static/media/ente-3-code.e2bda0c8.png";